export default "__VITE_ASSET__DRXayPOM__"